/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, answerError } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// EMBED : QUESTION : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	question: {
		height: '30%',
		textAlign: 'left',
		paddingTop: pxToEm(10),
		position: 'relative',
		zIndex: '3',
		'& .text': {
			// 24 chars per line at 22px fontsize
			// 56 is limit for 3 lines at 22px fontsize
			height: '100%',
			fontSize: pxToEm(21),
			fontWeight: 'normal',
			lineHeight: '1.1',
			'&.medium': { fontSize: pxToEm(18), lineHeight: '1.15' },
			'&.large': { fontSize: pxToEm(16), lineHeight: '1.15' },
			'&.xlarge': { fontSize: pxToEm(15), lineHeight: '1.15' },
			'&.xxlarge': { fontSize: pxToEm(13), lineHeight: '1.25' },
			'&.xxxlarge': { fontSize: pxToEm(10), lineHeight: '1.25' }

			// fontSize: pxToEm(22),
			// lineHeight: '1.1',
			// '&.medium': { fontSize: pxToEm(19), lineHeight: '1.2' },
			// '&.large': { fontSize: pxToEm(17), lineHeight: '1.2' },
			// '&.xlarge': { fontSize: pxToEm(16), lineHeight: '1.2' },
			// '&.xxlarge': { fontSize: pxToEm(14), lineHeight: '1.3' },
			// '&.xxxlarge': { fontSize: pxToEm(12), lineHeight: '1.3' }
		},
		'&.valid-false': {
			extend: answerError.text
		}
	}
});